import { configureStore } from '@reduxjs/toolkit';
import coachingReducer from './slices/coachingSlice';
import interviewReducer from './slices/interviewSlice';
import instructorReducer from './slices/instructorSlice';
import adminReducer from './slices/adminSlice';
import courseProgressReducer from './slices/courseProgressSlice';

export const store = configureStore({
  reducer: {
    coaching: coachingReducer,
    interview: interviewReducer,
    instructor: instructorReducer,
    admin: adminReducer,
    courseProgress: courseProgressReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;